module.exports = __webpack_public_path__ + "static/media/emoticon-excited-outline.06a0bea6.svg";